var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootcampjsclock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    rx: 10,
    fill: "#FBBF30",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0owwxlb8ja)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#sz04wfhuxb)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 17.067c-7.668 0-13.885 6.216-13.885 13.885s6.217 13.885 13.886 13.885c7.668 0 13.885-6.216 13.885-13.885S38.17 17.067 30.501 17.067z",
    fill: "#FBBF30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.71 17.5a.969.969 0 1 0-1.21-1.513l-3.23 2.584a.969.969 0 0 0 1.21 1.513l3.23-2.584zM39.502 15.987a.969.969 0 0 0-1.21 1.513l3.228 2.584a.969.969 0 1 0 1.21-1.513l-3.228-2.584z",
    fill: "#FBBF30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.729 20.245.39-.313-.39.313a1.469 1.469 0 0 0 2.064.229l3.23-2.583a1.469 1.469 0 0 0 .229-2.065l-.39.313.39-.313a1.469 1.469 0 0 0-2.065-.23l-3.229 2.584a1.469 1.469 0 0 0-.23 2.065zM30.5 16.567c-7.945 0-14.386 6.44-14.386 14.385 0 7.945 6.44 14.385 14.386 14.385 7.945 0 14.385-6.44 14.385-14.385 0-7.945-6.44-14.385-14.385-14.385zm9.313-.97a1.469 1.469 0 1 0-1.835 2.294l3.23 2.583a1.469 1.469 0 0 0 1.834-2.294l-3.229-2.583z",
    stroke: "url(#5pxj6xo2tc)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#efzq6rdh1d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.47 25.785a.969.969 0 0 0-1.937 0v5.433c0 .412-.158.808-.44 1.108l-1.88 1.993a.969.969 0 1 0 1.41 1.33l1.88-1.994c.62-.66.967-1.531.967-2.437v-5.433z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "sz04wfhuxb",
    x: -8.385,
    y: -9.225,
    width: 77.772,
    height: 79.063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_402_2468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_402_2468",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "efzq6rdh1d",
    x: 23.949,
    y: 21.817,
    width: 20.521,
    height: 27.136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_2468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_2468",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5pxj6xo2tc",
    x1: 16.615,
    y1: 15.775,
    x2: 45.661,
    y2: 43.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0owwxlb8ja"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15 15)",
    d: "M0 0h31v31H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjsclock);
export default __webpack_public_path__ + "static/media/Bootcamp js clock.96fdd50f6f8763e69a78cd372547a0aa.svg";
export { ForwardRef as ReactComponent };